import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/fa';

dayjs.extend(relativeTime);
dayjs.locale('fa');

const humanizeDayjs = (
  date: string | number | Date | null | undefined
): string => {
  if (!date) return '';
  return dayjs(date).fromNow();
};

export default humanizeDayjs;
